export default __webpack_public_path__ + "fonts/974f835d33f6b5d9c5d177cf23b34705.svg";